"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Checkbox = require("../../components/Checkbox");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Checkbox = {
  styles: function styles(theme) {
    return {
      root: {
        "&:hover": {
          "& svg": {
            borderColor: theme.colors.primary,
            boxShadow: "0 0 0 4px ".concat(theme.colors.primary, "33")
          }
        }
      },
      svg: {
        borderRadius: 4,
        borderColor: _Checkbox.vars.get("checkboxPrimary", theme.colors.baseContrast050),
        strokeWidth: 3,
        padding: 2
      },
      description: {
        color: theme.colors.baseContrast070,
        textTransform: "none"
      },
      hint: {
        textTransform: "none"
      }
    };
  }
};
var _default = exports.default = Checkbox;